import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { NgBusyModule } from 'ng-busy';

import { SearchCakesService } from './services/search-cakes.service';
import { BakeriesApiService } from '../api-services/services/bakeries-api.service';
import { DeliveryApiService } from '../api-services/services/delivery-api.service';
import { CitiesApiService } from '../api-services/services/cities-api.service';
import { DeliveryModule } from '../delivery/delivery.module';
import { SharedModule } from '../shared/shared.module';

import { PostNumberDeliveryCheckComponent } from './components/post-number-delivery-check/post-number-delivery-check.component';
import { FilterTagsComponent } from './components/filter-tags/filter-tags.component';
import { SearchCakesPanelMobileComponent } from './components/search-cakes-panel-mobile/search-cakes-panel-mobile.component';
import { CakeItemComponent } from './components/cake-item/cake-item.component';
import { BakeryDeliveryCheckComponent } from './components/bakery-delivery-check/bakery-delivery-check.component';
import { DeliveryCheckPanelComponent } from './components/delivery-check-panel/delivery-check-panel.component';
import { SearchCakesPanelComponent } from './components/search-cakes-panel/search-cakes-panel.component';
import { CheckDeliveryModalComponent } from './components/check-delivery-modal/check-delivery-modal.component';
import { CategoriesSelectorComponent } from './components/categories-selector/categories-selector.component';
import { CategoryGroupsSelectorComponent } from './components/category-groups-selector/category-groups-selector.component';
import {
  CategoriesMobileSelectorComponent
} from './components/categories-selector/categories-mobile-selector/categories-mobile-selector.component';

import { CakesListComponent } from './components/cakes-list/cakes-list.component';
import { CakeItemPriceComponent } from './components/cake-item-price/cake-item-price.component';
import { CakeCardFooterComponent } from './components/cake-item/cake-card-footer/cake-card-footer.component';
import { NoImageCakeItemComponent } from './components/cake-item/no-image-cake-item/no-image-cake-item.component';
import { CakeItemPiecesComponent } from './components/cake-item/cake-item-pieces/cake-item-pieces.component';
import { CakeItemPiecesGroupComponent } from './components/cake-item/cake-item-pieces-group/cake-item-pieces-group.component';
import { CakeItemComplexComponent } from './components/cake-item/cake-item-complex/cake-item-complex.component';
import { CakeItemCateringComponent } from './components/cake-item/cake-item-catering/cake-item-catering.component';
import { CakeItemRequestComponent } from './components/cake-item/cake-item-request/cake-item-request.component';
import { NullCakeItemComponent } from './components/cake-item/null-cake-item/null-cake-item.component';

const COMPONENTS = [
  SearchCakesPanelComponent,
  SearchCakesPanelMobileComponent,
  FilterTagsComponent,
  CakesListComponent,
  CakeItemComponent,
  DeliveryCheckPanelComponent,
  BakeryDeliveryCheckComponent,
  CheckDeliveryModalComponent,
  PostNumberDeliveryCheckComponent,
  CategoriesSelectorComponent,
  CategoryGroupsSelectorComponent,
  CategoriesMobileSelectorComponent,
];

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    NgBusyModule,
    NgCakeItEasyUtilsModule,
    DeliveryModule,
    NgbModule,
    ScrollToModule,
    TranslateModule,

    CakeItEasyWebUiModule,
    SharedModule,
    CakeItemPriceComponent,
    CakeItemPiecesComponent,
    CakeItemPiecesGroupComponent,
    CakeItemComplexComponent,
    CakeItemCateringComponent,
    CakeItemRequestComponent,
  ],
  declarations: [
    ...COMPONENTS,

    CakeCardFooterComponent,
    NoImageCakeItemComponent,
    NullCakeItemComponent
  ],
  exports: [
    ...COMPONENTS,
    CakeItemPriceComponent,
  ],
  providers: [
    BakeriesApiService,
    CitiesApiService,
    DeliveryApiService
  ]
})
export class CakesOverviewModule {
  static forRoot(): ModuleWithProviders<CakesOverviewModule> {
    return {
      ngModule: CakesOverviewModule,
      providers: [
        SearchCakesService
      ]
    };
  }
}
